// react
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import type { FallbackProps } from 'react-error-boundary';
// components
import MainContent from '@/components/Layout/components/MainContent';
import Navbar from '@/components/Layout/components/Navbar';
import PromptDrawer from '@/modules/PromptDrawer';
import ActLogDrawer from '@/modules/ActLogDrawer';
import ActReportDrawer from '@/modules/ActReportDrawer';
import Search from '@/components/Layout/components/Search';
import SuspenseLoader from '@/components/Layout/components/SuspenseLoader';
// utils
import { MENU_PORTAL, POPOVER_PORTAL, TOOLTIP_PORTAL } from '@/const';

function fallbackRender({ error }: FallbackProps) {
    const message = error instanceof Error ? error.message : String(error);

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{message}</pre>
        </div>
    );
}

const Layout = () => {
    return (
        <>
            <Navbar />
            <MainContent>
                <Suspense fallback={<SuspenseLoader />}>
                    <ErrorBoundary fallbackRender={fallbackRender}>
                        <Outlet />
                    </ErrorBoundary>
                </Suspense>
            </MainContent>
            <PromptDrawer />
            <ActLogDrawer />
            <ActReportDrawer />
            <Search />
            <div id={POPOVER_PORTAL} />
            <div id={TOOLTIP_PORTAL} />
            <div id={MENU_PORTAL} />
        </>
    );
};

export default Layout;
